<style lang="scss" scoped>
.panel-info {
    border: 1px solid #67809f;
    margin-bottom: 15px;
    &-title {
        line-height: 40px;
        background-color: #67809f;
        color: #fff;
        padding: 0 15px;
    }
    article {
        overflow: hidden;
        line-height: 2.6;
        color: #333;
        padding: 15px;
        & > span {
            float: left;
            min-width: 120px;
            width: 35%;
            &:nth-of-child(even) {
                width: 60%;
            }
        }
    }
}
</style>


<template>
<div>
	<div class="panel-info" >
		<h3 class="panel-info-title">
			<Icon type="ios-person" size="16"></Icon>
			{{$t('port.panel_info.info')}}
		</h3>
		<article>
			<span>{{$t('port.panel_info.user')}}:</span>
			<span>{{userinfo.name}}</span>
			<span>{{$t('port.panel_info.ip')}}：</span>
			<span>{{userinfo.lastLoginIp}}</span>
			<span>{{$t('port.panel_info.attime')}}：</span>
			<span>{{userinfo.lastLoginTime}}</span>
			<span>{{$t('port.panel_info.updated')}}：</span>
			<span>{{userinfo.updated}}</span>
		</article>
	</div>
</div>
</template>


<script>
import { mapState } from 'vuex';
export default {
	computed: {
		...mapState(['userinfo']),
	},
};
</script>
